import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
	palette: {
		background: {
			default: '#41110f33',
		},
		primary: {
			main: '#541d18',
		},
		secondary: {
			main: '#19857b',
		},
		error: {
			main: red.A400,
		},
	},
	typography: {
		allVariants: {
			textTransform: 'none',
			color: 'black',
			lineHeight: 'initial',
		},
		fontFamily: 'Poppins, sans-serif',
	},
});

export default theme;
